module.exports = __webpack_public_path__ + "img/josselin-gesrel.a9cee4d5.jpg";